export const TEST_IDS = {
  listRowRepoNameAndNumber: 'list-row-repo-name-and-number',
  listRowStateIcon: 'list-row-state-icon',
  listRowComments: 'list-row-comments',
  listRowAssignees: 'list-row-assignees',
  listRowLabels: 'list-row-labels',
  listRowLinkedPullRequests: 'list-row-linked-pull-requests',
}
